/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CalendarStatus =
  | 'ACTIVE'
  | 'INACTIVE';

export type AvailableCalendarsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCalendarsQuery = { currentEntrance: { calendarSummaries: Array<{ guid: string, status: Types.CalendarStatus, publicTitle: string, privateTitle: string | null }> } };


export const AvailableCalendarsDocument = gql`
    query availableCalendars {
  currentEntrance {
    calendarSummaries {
      guid
      status
      publicTitle
      privateTitle
    }
  }
}
    `;

/**
 * __useAvailableCalendarsQuery__
 *
 * To run a query within a Vue component, call `useAvailableCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCalendarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvailableCalendarsQuery();
 */
export function useAvailableCalendarsQuery(options: VueApolloComposable.UseQueryOptions<AvailableCalendarsQuery, AvailableCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailableCalendarsQuery, AvailableCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailableCalendarsQuery, AvailableCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AvailableCalendarsQuery, AvailableCalendarsQueryVariables>(AvailableCalendarsDocument, {}, options);
}
export function useAvailableCalendarsLazyQuery(options: VueApolloComposable.UseQueryOptions<AvailableCalendarsQuery, AvailableCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AvailableCalendarsQuery, AvailableCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AvailableCalendarsQuery, AvailableCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AvailableCalendarsQuery, AvailableCalendarsQueryVariables>(AvailableCalendarsDocument, {}, options);
}
export type AvailableCalendarsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AvailableCalendarsQuery, AvailableCalendarsQueryVariables>;